import { getMessagesByName } from 'api/api';
import Spinner from 'components/Spinner';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import { ChatMessage } from 'domain/domain';
import { Grid, makeStyles, TextField } from '@material-ui/core';
import { createDefaultTableOptions } from 'utils/utils';
import moment from 'moment';

const useStyles = makeStyles(_ => ({
    root: {
        maxWidth: '90%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 50
    },
    textField: {
        padding: 5
    }
}));

const Messages : React.FC = () => {

    const [loading, setLoading] = useState<boolean>(false);
    const history = useHistory();
    const [messages, setMessages] = useState<ChatMessage[]>([]);
    const [page, setPage] = useState<number>(0);
    const [totalElements, setTotalElements] = useState<number>(0);
    const params : any = useParams();
    const classes = useStyles();
    const [sender, setSender] = useState<string>(params.name === "_" ? "" : params.name);
    const [changeId, setChangeId] = useState<number>(0);
    const [query, setQuery] = useState<string>(params.query);

    useEffect(() => {
        if (sender || query) {
            let name = sender;
            setLoading(true);
            getMessagesByName(name, query, page).then(response => {
                setMessages(response.data.content);
                setTotalElements(response.data.totalElements);
            }).catch(error => {
                console.error(error);
            }).finally(() => {
                setLoading(false);
            })
        }
    }, [page, changeId]);

    const columns = [
        {
            name: 'timestamp',
            label: 'Date',
            options: {
                customBodyRender: (value: string) => <span>{moment(value).format('DD-MM-YYYY HH:mm:ss')}</span>
            }
        },
        {
            name: 'sender',
            label: 'Sender'
        },
        {
            name: 'content',
            label: 'Message'
        }
    ]

    const handleSubmit = () => {
        console.log(sender + " " + query);
        if (sender) {
            if (query) {
                history.push("/messages/" + sender + "/" + encodeURIComponent(query));
            } else {
                history.push("/messages/" + sender);
            }
        } else {
            if (query) {
                history.push("/messages/_/" + encodeURIComponent(query));
            } else {
                history.push("/messages/");
            }
        }
        setChangeId(changeId + 1);
    }

    const options = {
        ...createDefaultTableOptions(),
        page: page,
        count: totalElements,
        rowsPerPage: 20,
        serverSide: true,
        onTableChange: (action: string, tableState: any) => {
            switch (action) {
              case "changePage":
                setPage(tableState.page);
                break;
            }
        }
    }

    const keyPress = (e: any) => {
        if(e.keyCode == 13){
           handleSubmit();
        }
     }

    return (
        <Grid container direction='column' className={classes.root}>
            <Grid item>
                    <TextField
                        className={classes.textField}
                        InputLabelProps={{shrink: true}}
                        label="Sender"
                        value={sender}
                        onKeyDown={keyPress}
                        onChange={(event) => setSender(event.target.value)
                        }
                    />
                    <TextField
                        className={classes.textField}
                        InputLabelProps={{shrink: true}}
                        label="Query"
                        value={query}
                        onKeyDown={keyPress}
                        onChange={(event) => setQuery(event.target.value)
                    }
                />
            </Grid>
            <Grid item>
                {loading && (
                    <Spinner />
                )}
                {!loading && (
                    <MUIDataTable
                        title={params.name === "_" ? "" : params.name}
                        columns={columns}
                        data={messages}
                        options={options}
                    />
                )}
            </Grid>
        </Grid>
    )

}

export default Messages;